import {
    ALERT_SETTINGS_TOGGLE_RIGHTPANEL,
    ALERT_SETTINGS_UPDATE_CHANNELS,
    ALERT_SETTINGS_UPDATE_MANAGE
  } from "../actions/alert-settings/types";
  
  const INITIAL_STATE = {
      rightPanelExpanded: false,
      channels: {
        ipaws: {
          status: null,
        },
        facebook: {
          status: null,
          list: []
        },
        twitter: {
          status: null,
          list: []
        }
      },
      manage: {
        groups: {
          status: null,
          list: []
        }
      } 
  };
  
  export default (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
      case ALERT_SETTINGS_TOGGLE_RIGHTPANEL:
        return {
          ...state,
          rightPanelExpanded: action.payload
        };
      case ALERT_SETTINGS_UPDATE_CHANNELS:
        return {
          ...state,
          channels: action.payload 
        };
      case ALERT_SETTINGS_UPDATE_MANAGE:
        return {
          ...state,
          manage: action.payload 
        };
      default:
        return state;
    }
  };
  


// WEBPACK FOOTER //
// ./src/reducers/Alert-Settings.tsx